document.addEventListener("DOMContentLoaded", function() {
    var selected_variant = $('.hidden_selected_id');
  if(selected_variant){

    console.log(parseInt(selected_variant.attr('data_stck')));
      if(parseInt(selected_variant.attr('data_stck')) < 5 && parseInt(selected_variant.attr('data_stck')) > 0 && selected_variant.attr('data_inventory_policy') == 'deny'){
        
        $('.stock_indicator_block').show();
      }
      else if(parseInt(selected_variant.attr('data_stck')) == 0){
        $('.stock_indicator_block').hide();  
      }
      else{
        $('.stock_indicator_block').hide();
      }
  }
});

var sizeGuideTrigger = document.getElementById("custom-size-guide");
var sizeGuidePopup = document.getElementById("size-guide--popup");
var siteControlInner = document.getElementById("site-control");
var closeButton = document.getElementById("size_modal_close");
var outercloseButton = document.getElementById("size_modal_background");

if (sizeGuideTrigger) {
    sizeGuideTrigger.addEventListener("click", function () {
        if (sizeGuidePopup) sizeGuidePopup.style.display = "block";
        if (outercloseButton) outercloseButton.style.display = "flex";
        document.body.style.overflow = "hidden";
        if (siteControlInner) siteControlInner.classList.add("active");
    });
}

if (closeButton) {
    closeButton.addEventListener("click", function () {
        if (sizeGuidePopup) sizeGuidePopup.style.display = "none";
        if (outercloseButton) outercloseButton.style.display = "none";
        if (siteControlInner) siteControlInner.classList.remove("active");
        document.body.style.overflow = "";
    });
}

if (outercloseButton) {
    outercloseButton.addEventListener("click", function () {
        if (sizeGuidePopup) sizeGuidePopup.style.display = "none";
        outercloseButton.style.display = "none";
        if (siteControlInner) siteControlInner.classList.remove("active");
        document.body.style.overflow = "";
    });
}

// ============================================================================================================================================================

// document.addEventListener('DOMContentLoaded', () => {
//   const TEMPLATE = 'new-apparel-pdp';
//   if (!document.documentElement.innerHTML.includes(TEMPLATE)) return;
  
//     let colorOptionIndex;
//     window.colorpicker = function (color) {
//       const options = color.options;
//       for (let i = 0; i < options.length; i++) {
//         if (options[i] === "Color" || options[i] === "Colour") {
//           colorOptionIndex = i;
//           break;
//         }
//       }
//     };

//     window.variantpicker = function (variant) {
//       const variantselect = variant.options[colorOptionIndex];
//       imagefilter(variantselect);
//     };

//   function imagefilter(colorselect , variantselect){
//     document.querySelectorAll(".theme-img").forEach(item =>{
//       const img = item.querySelector("img");
//       if(img.alt == colorselect || img.alt == ''){
//         item.style.display = "block"
//       }
//       else{
//         item.style.display = "none"
//       }
//     });
//     setTimeout(() => {
//       document.querySelectorAll('.swiper, .swiper-container').forEach(s => {
//         if (s.swiper) {
//           s.swiper.updateSlides();
//           s.swiper.update();
//           s.swiper.slideTo(0, 0);
//         }
//       });
//       if (window.theme && window.theme.swipers) {
//         Object.values(window.theme.swipers).forEach(swiperObj => {
//           if (swiperObj && typeof swiperObj.slideTo === 'function') {
//             swiperObj.updateSlides?.();
//             swiperObj.update?.();
//             swiperObj.slideTo(0, 0);
//           }
//         });
//       }
//       window.dispatchEvent(new Event('resize'));
//     }, 50);
//   }
//   const loadImage = (el) => {
//     (el.matches('.lazyload,.lazyload--manual')
//       ? [el]
//       : el.querySelectorAll('.lazyload,.lazyload--manual')
//     ).forEach((img) => {
//       img.classList.remove('lazyload--manual');
//       img.classList.add('lazyload');
//     });
//   };

//   const refresh = () => {
//     document.body.offsetHeight;
//     window.dispatchEvent(new Event('resize'));

//     window.jQuery &&
//       ['resize', 'debouncedresize', 'debouncedresizewidth', 'throttled-scroll']
//         .forEach(e => jQuery(window).trigger(e));

//     document.querySelectorAll('.swiper').forEach(s => {
//       if (!s.swiper) return;
//       s.swiper.updateSlides();
//       s.swiper.updateAutoHeight?.();
//       s.swiper.update();
//       s.swiper.slideTo(0, 0);
//     });

//     window.lazySizes?.autoSizer?.checkElems();
//   };
// });

document.addEventListener('DOMContentLoaded', () => {
  const TEMPLATE = 'new-apparel-pdp';
  if (!document.documentElement.innerHTML.includes(TEMPLATE)) return;

  let colorOptionIndex;
  window.colorpicker = function (color) {
    const options = color.options;
    for (let i = 0; i < options.length; i++) {
      if (options[i] === "Color" || options[i] === "Colour") {
        colorOptionIndex = i;
        break;
      }
    }
  };

  window.variantpicker = function (variant) {
    const variantselect = variant.options[colorOptionIndex];
    syncHiddenRadio(variantselect);
  };

  function syncHiddenRadio(colorValue) {
    const productWrapper = document.querySelector('.product-area');
    if (!productWrapper) return;
    const productId = productWrapper.dataset.productId;

    const radio = document.getElementById(
      `cc-color-sync-${productId}-${colorValue.toLowerCase().replace(/\s+/g, '-')}`
    );
    if (radio) {
      radio.checked = true; // CSS :has() yahi se trigger hoga, filtering CSS khud karega
    }

    setTimeout(() => {
      document.querySelectorAll('.swiper, .swiper-container').forEach(s => {
        if (s.swiper) {
          s.swiper.updateSlides();
          s.swiper.update();
          s.swiper.slideTo(0, 0);
        }
      });
      window.dispatchEvent(new Event('resize'));
    }, 50);
  }
});